module.exports = __webpack_public_path__ + "static/sunset-2e8b6d52b548fe64fb09ab4f2a4d1d2d.jpg";